import { Trans } from "@lingui/macro";
import React, { FormEvent } from "react";
import { Button } from "components/UI/Button/Button";
import { QrcodeIcon } from "@heroicons/react/outline";
import { InputText } from "components/UI/InputText/InputText";

export type typeBarcodeSearch = {
  onSearch: (barcode: string) => void;
};

export const BarcodeSearch: React.FC<typeBarcodeSearch> = ({ onSearch }) => {
  const [searchValue, setSearchValue] = React.useState("");

  const onSearchSubmit = (e: FormEvent | MouseEvent | TouchEvent) => {
    e.preventDefault();

    if (!!searchValue.trim()) {
      onSearch(searchValue.trim());

      setSearchValue("");
    } else {
      return;
    }
  };

  return (
    <div className="flex gap-2" onSubmit={(e) => onSearchSubmit(e)}>
      <div className="flex gap-2 items-center text-lg font-medium">
        <QrcodeIcon className="h-10 w-10 text-gray-600" />

        <span className="hidden sm:block">
          <Trans>Search by barcode</Trans>
        </span>
      </div>

      <div className="flex-grow">
        <InputText
          id="qrsearch"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>

      <Button
        type="submit"
        label={<Trans>Search</Trans>}
        onClick={(e) => onSearchSubmit(e)}
      />
    </div>
  );
};
